import { render } from "./FeatureBlocks.vue?vue&type=template&id=25ebb2c7"
import script from "./FeatureBlocks.vue?vue&type=script&lang=js"
export * from "./FeatureBlocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/FeatureHighlight/FeatureBlocks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25ebb2c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25ebb2c7', __exports__)) {
    api.reload('25ebb2c7', __exports__)
  }
  
  module.hot.accept("./FeatureBlocks.vue?vue&type=template&id=25ebb2c7", () => {
    api.rerender('25ebb2c7', render)
  })

}


export default __exports__